import {Component} from 'react';

export default class Tutorial extends Component {

  changeHighlightRingPosition = (selector, stateProperty = "ringStyles") => {
    const highlightElement = document.querySelector(selector);
    if (highlightElement) {
      const rect = highlightElement.getBoundingClientRect();
      this.setState({
        [stateProperty]: {
          left: rect.left,
          top: rect.top,
        }
      })
    }
  };

}
